/**
 * CRA/webpack loads @azure/msal-browser through this CJS shim so the bundler
 * uses the package "require" entry. Direct ESM imports break after
 * scripts/fix-msal-webpack.js points the "import" condition at the CJS bundle.
 */
// eslint-disable-next-line import/no-extraneous-dependencies, import/no-commonjs, global-require
module.exports = require('@azure/msal-browser');
